import React from "react";
import { useTranslation } from 'react-i18next';

export default function Translator({ id, S1, noSpan }) {
  const { t } = useTranslation();
  let message = t(id);
  if(S1) message = message.replace("@S1", S1);
  return (
    <>
      {
        !noSpan ? <span>{message}</span> : message
      }
    </>
  )
}